<button (click)="redirectToMalfunction()" class="shortcut-menu__button">
  <svg-icon src="assets/images/icons/notification.svg"></svg-icon>
  <span>{{ "ShortcutMenu.Malfunction" | translate }}</span>
  <div [class.red]="messages().length" class="shortcut-menu__badge">{{ messages().length }}</div>
</button>
